import createSvgIcon from '../Utils/CreateSvgIcon';

export const Close = createSvgIcon(
  <path d="M13.4142 12L20.7071 4.70709L19.2928 3.29288L12 10.5858L4.70706 3.29288L3.29285 4.70709L10.5857 12L3.29285 19.2929L4.70706 20.7071L12 13.4142L19.2928 20.7071L20.7071 19.2929L13.4142 12Z" />,
  'Close',
);
